module.exports = __webpack_public_path__ + "img/ref-3.bd1f9d13.jpg";